import { z } from 'zod';
export const pulseReplyMailboxOptionSchema = z.object({
    connectionId: z.string().uuid(),
    emailAddress: z.string().email(),
});
/** Whether a Lead's "Email" composer can actually send (vs. only log) — a
 * lead only has a mailbox to reply through if it has at least one inbound
 * Inbox Pulse message on record. `mailboxEmail` is always the one that
 * would be used by default (the mailbox whose thread with this lead is
 * most recent) — `options` is only present when more than one of the
 * tenant's connected mailboxes has its own separate thread with this lead
 * (e.g. two reps each emailed the same contact), so the composer can offer
 * a picker instead of always silently using the most recent one.
 *
 * A lead with NO thread yet (e.g. created directly via the MCP tools or a
 * web form, never emailed through Pulse) can't reply within anything, but
 * can still start one: `canCompose`/`composeOptions` list the signed-in
 * member's own active mailbox connections to send a first email from —
 * scoped to connections THEY own, the same owner-only boundary completing
 * a mailbox OAuth already has, even though admins can see every tenant
 * connection for visibility. */
export const pulseReplyContextResponseSchema = z.object({
    canReply: z.boolean(),
    mailboxEmail: z.string().email().optional(),
    options: z.array(pulseReplyMailboxOptionSchema).optional(),
    reason: z.string().optional(),
    canCompose: z.boolean().optional(),
    composeOptions: z.array(pulseReplyMailboxOptionSchema).optional(),
});
export const sendPulseReplyInputSchema = z.object({
    bodyText: z.string().trim().min(1).max(10_000),
    /** Which mailbox's thread to reply within — omit to use the default
     * (most recent) one `getReplyContext` would report. */
    connectionId: z.string().uuid().optional(),
});
export const sendPulseReplyResponseSchema = z.object({ activityId: z.string().uuid() });
/** Starts a brand new thread (no prior message to reply within), so unlike
 * `sendPulseReplyInputSchema` the mailbox is required, not a default, and
 * there's a real subject line instead of an auto "Re: ..." prefix. */
export const sendPulseComposeInputSchema = z.object({
    connectionId: z.string().uuid(),
    subject: z.string().trim().min(1).max(200),
    bodyText: z.string().trim().min(1).max(10_000),
});
/** Appended to every reply this member sends through Inbox Pulse — personal,
 * like the mailbox connection itself, not a tenant-wide template. */
export const pulseSignatureResponseSchema = z.object({ signature: z.string().nullable() });
export const updatePulseSignatureInputSchema = z.object({ signature: z.string().trim().max(1000) });
//# sourceMappingURL=reply.js.map